import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

export const codeNameFilterOption = (option: any, searchText: string): boolean => {
  if (!searchText) {
    return true;
  }
  const search = searchText.toLowerCase();
  if (option.data.value === EMPTY_FILTER_VALUE) {
    return String(option.data.label?.props?.children ?? option.data.label ?? '')
      .toLowerCase()
      .includes(search);
  }
  const props = option.data.label?.props ?? {};
  const name = String(props.itemName ?? '').toLowerCase();
  const id = String(props.itemId ?? '').toLowerCase();
  return name.includes(search) || id.includes(search);
};

export const nativeCodeNameFilterOption = (option: any, searchText: string): boolean => {
  if (!searchText) {
    return true;
  }
  const search = searchText.toLowerCase();
  if (option.data.value === EMPTY_FILTER_VALUE) {
    return String(option.data.label?.props?.children ?? option.data.label ?? '')
      .toLowerCase()
      .includes(search);
  }
  const name = String(option.data.label ?? '').toLowerCase();
  const code = String(option.data.code ?? '').toLowerCase();
  return name.includes(search) || code.includes(search);
};
